import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Drawer } from '@sainsburys-tech/bolt';
import CarePrice from '../CarePrice/CarePrice';
import ProductCareContent from '../ProductCareContent/ProductCareContent';
import ProductCareFooter from '../ProductCareFooter/ProductCareFooter';
import Analytics from '../../ProductCareTracking';
import careTypes from '../../config/careTypes';
import * as Styled from './ProductCareItem.styles';

var Item = function Item(_ref) {
  var triggerModal = _ref.triggerModal,
      price = _ref.price,
      title = _ref.title,
      _ref$quantity = _ref.quantity,
      quantity = _ref$quantity === void 0 ? 1 : _ref$quantity,
      isMonthly = _ref.isMonthly,
      dataTest = _ref.dataTest,
      careType = _ref.careType,
      showInfoMessage = _ref.showInfoMessage;

  if (isMonthly && showInfoMessage) {
    return /*#__PURE__*/React.createElement(Styled.ProductCareCTA, {
      onClick: triggerModal,
      "data-test": "".concat(dataTest, "-CTA"),
      "data-care-type": careType,
      id: dataTest,
      showInfoMessage: showInfoMessage
    }, /*#__PURE__*/React.createElement(Styled.Wrapper, null, /*#__PURE__*/React.createElement(Styled.Title, {
      "data-test": "".concat(dataTest, "-name")
    }, title), /*#__PURE__*/React.createElement(Styled.ProductCarePriceContainer, null, /*#__PURE__*/React.createElement(CarePrice, {
      quantity: quantity,
      price: price,
      isMonthly: isMonthly,
      dataTest: dataTest
    }), /*#__PURE__*/React.createElement(Styled.ChevronContainer, {
      width: "24px",
      height: "24px",
      dir: "right"
    }))), /*#__PURE__*/React.createElement(Styled.BoltAlert, {
      kind: "info",
      isCloseable: false
    }, "To add monthly care, buy your item first and add after your order is confirmed."));
  }

  return /*#__PURE__*/React.createElement(Styled.ProductCareCTA, {
    onClick: triggerModal,
    "data-test": "".concat(dataTest, "-CTA"),
    "data-care-type": careType,
    id: dataTest
  }, /*#__PURE__*/React.createElement(Styled.Title, {
    "data-test": "".concat(dataTest, "-name")
  }, title), /*#__PURE__*/React.createElement(Styled.ProductCarePriceContainer, null, /*#__PURE__*/React.createElement(CarePrice, {
    quantity: quantity,
    price: price,
    isMonthly: isMonthly,
    dataTest: dataTest
  }), /*#__PURE__*/React.createElement(Styled.ChevronContainer, {
    width: "24px",
    height: "24px",
    dir: "right"
  })));
};

var ProductCareItem = function ProductCareItem(_ref2) {
  var _careTypes$careType, _careTypes$careType2;

  var analytics = _ref2.analytics,
      quantity = _ref2.quantity,
      careType = _ref2.careType,
      _ref2$warrantyName = _ref2.warrantyName,
      warrantyName = _ref2$warrantyName === void 0 ? careTypes[careType].name : _ref2$warrantyName,
      warrantyPrice = _ref2.warrantyPrice,
      synapticaId = _ref2.synapticaId,
      ipidLink = _ref2.ipidLink,
      leafletLink = _ref2.leafletLink,
      overwriteAddToTrolley = _ref2.overwriteAddToTrolley,
      hostPartNumber = _ref2.hostPartNumber,
      hostProductName = _ref2.hostProductName,
      hostPrice = _ref2.hostPrice,
      warrantyItem = _ref2.warrantyItem,
      warrantyPartNumber = _ref2.warrantyPartNumber,
      onlyWarranty = _ref2.onlyWarranty,
      onAddToTrolley = _ref2.onAddToTrolley,
      overwriteCTAText = _ref2.overwriteCTAText,
      showInfoMessage = _ref2.showInfoMessage,
      _ref2$dataTest = _ref2['data-test'],
      dataTest = _ref2$dataTest === void 0 ? 'product-care-item' : _ref2$dataTest;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      show = _useState2[0],
      toggleShow = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      hasAgreeTerms = _useState4[0],
      _setHasAgreeTerms = _useState4[1];

  var isMonthly = careType.includes('monthly_care');
  var leafletCopy = ((_careTypes$careType = careTypes[careType]) === null || _careTypes$careType === void 0 ? void 0 : _careTypes$careType.leafletCopy) || 'Terms & Conditions';
  var contentAttr = {
    warrantyName: warrantyName,
    warrantyPrice: warrantyPrice,
    quantity: quantity,
    hostPartNumber: hostPartNumber,
    hostProductName: hostProductName,
    hostPrice: hostPrice,
    warrantyItem: warrantyItem,
    onlyWarranty: onlyWarranty,
    dataTest: dataTest,
    careType: careType,
    isMonthly: isMonthly
  };

  var analyticsData = _objectSpread(_objectSpread({}, analytics), {}, {
    quantity: quantity,
    hostPartNumber: hostPartNumber,
    hostPrice: hostPrice,
    warrantyPartNumber: warrantyPartNumber,
    warrantyPrice: warrantyPrice,
    isMonthly: isMonthly
  });

  var partNumbers = onlyWarranty ? warrantyPartNumber : [hostPartNumber, warrantyPartNumber];

  var handleOpenDrawer = function handleOpenDrawer() {
    toggleShow(true);
    Analytics.onProductCareSlidingPanelOpen(analyticsData, window);
  };

  var handleAddToTrolley = function handleAddToTrolley() {
    if (overwriteAddToTrolley) overwriteAddToTrolley();
    if (!isMonthly && onAddToTrolley) onAddToTrolley(true, {
      name: warrantyName,
      partnumber: warrantyPartNumber,
      price: warrantyPrice
    });
    toggleShow(false);
    Analytics.onProductCareSlidingPanelClose(analyticsData, window);
    if (!isMonthly) Analytics.onProductCareAddToTrolley(analyticsData, window);
  };

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Item, {
    triggerModal: handleOpenDrawer,
    quantity: quantity,
    isMonthly: isMonthly,
    price: warrantyPrice,
    title: warrantyName,
    dataTest: dataTest,
    careType: careType,
    showInfoMessage: showInfoMessage
  }), /*#__PURE__*/React.createElement(Drawer, {
    heading: (_careTypes$careType2 = careTypes[careType]) === null || _careTypes$careType2 === void 0 ? void 0 : _careTypes$careType2.header,
    position: "right",
    show: show,
    onClose: function onClose() {
      Analytics.onProductCareSlidingPanelClose(analyticsData, window);
      toggleShow(false);
    },
    padding: false,
    "data-test": "".concat(dataTest, "-drawer"),
    ariaLabelledBy: dataTest,
    footer: /*#__PURE__*/React.createElement(ProductCareFooter, {
      synapticaId: synapticaId,
      ipidLink: ipidLink,
      leafletCopy: leafletCopy,
      leafletLink: leafletLink,
      addToTrolley: handleAddToTrolley,
      partNumbers: partNumbers,
      hasAgreeTerms: hasAgreeTerms,
      setHasAgreeTerms: function setHasAgreeTerms(hasAgreed) {
        if (hasAgreed) {
          Analytics.onProductCareAcceptTerms(analyticsData, window);
        }

        _setHasAgreeTerms(hasAgreed);
      },
      overwriteAddToTrolley: overwriteAddToTrolley,
      isMonthly: isMonthly,
      overwriteCTAText: overwriteCTAText,
      "data-test": "".concat(dataTest, "-footer")
    })
  }, /*#__PURE__*/React.createElement(ProductCareContent, contentAttr)));
};

ProductCareItem.propTypes = {
  /**
   * Title of the warranty item
   */
  warrantyName: PropTypes.string,

  /**
   * Price of the warranty item
   */
  warrantyPrice: PropTypes.number.isRequired,

  /**
   * Synaptica Id of the warranty item [DEPRECATED] use the links provided by product-care service
   */
  synapticaId: PropTypes.string,

  /**
   * Warranty IPID link
   */
  ipidLink: PropTypes.string,

  /**
   * Warranty Leaflet link
   */
  leafletLink: PropTypes.string,

  /**
   * Callback function which is called when user clicks the CTA
   */
  onAddToTrolley: PropTypes.func,

  /**
   * The quantity of the "host product" - the product the user is buying warranty for
   */
  quantity: PropTypes.number,

  /**
   * The part number of the "host product" - the product the user is buying warranty for
   */
  hostPartNumber: PropTypes.string.isRequired,

  /**
   * The product name  of the "host product" - the product the user is buying warranty for
   */
  hostProductName: PropTypes.string.isRequired,

  /**
   * The price of the "host product" - the product the user is buying warranty for
   */
  hostPrice: PropTypes.number.isRequired,

  /**
   * Hides the product details section in the drawer, showing just the legal content
   */
  warrantyItem: PropTypes.bool,

  /**
   * The part number of the warranty product
   */
  warrantyPartNumber: PropTypes.string.isRequired,

  /**
   * Use when the "host product" has already been added to trolley, and the user is just adding warranty
   */
  onlyWarranty: PropTypes.bool,

  /**
   * Funtion to replace the default add to trolley button behaviour
   */
  overwriteAddToTrolley: PropTypes.func,

  /**
   * String to specify the copy used for each care type. Required in title case as it's directly used in the modal
   */
  careType: PropTypes.oneOf(['breakdown_care', 'epc_care', 'furniture_care', 'mobile_care', 'monthly_care', 'monthly_care_excess', 'replacement_care']).isRequired,

  /**
   * String in case is Monthly kind and you want to overwrite the button text
   */
  overwriteCTAText: PropTypes.string,

  /**
   * Specify an optional data-test attribute to be added for e2e testing
   */
  'data-test': PropTypes.string,

  /**
   * Optional flag to show info message
   */
  showInfoMessage: PropTypes.bool,

  /**
   * Analytics data. Can disable specific tracking events.
   */
  analytics: PropTypes.shape({
    pageName: PropTypes.string,
    clickOrigin: PropTypes.string,
    monthlyPageName: PropTypes.string,
    monthlyClickOrigin: PropTypes.string,
    shouldTrackTermsAndConditions: PropTypes.bool,
    shouldTrackAddToTrolley: PropTypes.bool,
    shouldTrackCloseModal: PropTypes.bool,
    shouldTrackRemoveFromTrolley: PropTypes.bool,
    itemIndex: PropTypes.number,
    pageIdentifier: PropTypes.string
  })
};
ProductCareItem.defaultProps = {
  quantity: 1,
  onlyWarranty: false,
  analytics: {
    shouldTrackTermsAndConditions: true,
    shouldTrackAddToTrolley: true,
    shouldTrackCloseModal: true,
    shouldTrackRemoveFromTrolley: true
  },
  warrantyItem: false,
  showInfoMessage: false
};
export default ProductCareItem;